import React, { useContext, useEffect, useState } from 'react'

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Stack from 'react-bootstrap/Stack'

import AppContext from '../context/app'
import useGetSiteMetadata from '../hooks/useGetSiteMetadata'
import CartItem from './cart-item'
import Subtotal from './subtotal'
import PromoCode from './promo-code'
import FreeCheckout from './checkout-free'

import ESW_CLASSNAMES from '../esw/classnames'
import cancelicon from '../images/svgs/cancel-icon-black.svg'
import creditcard from '../images/svgs/credit-card-icon-black.svg'

import '../styles/animations/animate-cart.scss'
import '../styles/animations/animate-cart-background.scss'
import { BASE_COUNTRY_ISO } from '../../gatsby-node/constants'

export default function Cart() {
    const { cart, showCart, setShowCart, country, screenWidth, prices } = useContext(AppContext)
    const { brandName } = useGetSiteMetadata()

    const [isFreeCheckout, setIsFreeCheckout] = useState(false)
    const [showFreeCheckout, setShowFreeCheckout] = useState(false)
    const [somePromotion, setSomePromotion] = useState(false)
    const [everyItemHasPrice, setEveryItemHasPrice] = useState(true)

    useEffect(() => {
        if (!prices || !country || !cart?.items?.length) return
        const array = cart.items.slice()
        for (let i = 0; i < array.length; i++) {
            const item = array[i]
            
            const price = prices[item.product_id][country.node.country_iso_code]
            const baseprice = prices[item.product_id][BASE_COUNTRY_ISO]

            if (baseprice?.promotion_price) setSomePromotion(true)
            if(!price) setEveryItemHasPrice(false)
        }
    }, [prices, country, cart])
    
    useEffect(() => {
        if (typeof document === 'undefined') return
        if (showCart) document.body.classList.add('overflow-hidden')
        else document.body.classList.remove('overflow-hidden')
    }, [showCart])

    useEffect(() => {
        const total_cart_price = parseFloat(cart?.total_cart_price)
        const total_discount = parseFloat(cart?.total_discount)
        
        if (isNaN(total_discount)) {
            setIsFreeCheckout(false)
            return
        }
        
        if ((total_cart_price - total_discount) === 0) {
            setIsFreeCheckout(true)
        } else {
            setIsFreeCheckout(false)
        }
    }, [cart])

    return (
        <div
            className='position-absolute d-flex flex-column'
            style={{
                left: 0,
                zIndex: 1,
                width: '100%',
                height: '100vh',
                transition: 'top .5s ease-in-out',
                top: showCart ? '100%' : '-100vh',
            }}
        >
            {/* THE CART (UNDER THE NAVBAR) */}
            <Container fluid
                onClick={() => { if(!cart?.items){ setShowCart(false) }}}
                className='overflow-auto bg-light position-relative'
                style={{
                    flexBasis: screenWidth < 768 ? '100%' : '70%',
                    flexGrow: 1,
                    flexShrink: 1,
                }}
            >
                {
                    showFreeCheckout
                        ?
                        <FreeCheckout
                            setShowFreeCheckout={setShowFreeCheckout}
                        />
                        :
                        <Container style={{ paddingBottom: screenWidth < 768 ? 220 : 0 }}>
                            <p className='ff-primary fw-bold my-3'>CART</p>

                            {/* CART ITEMS */}
                            <Row className='overflow-auto' style={{ maxHeight: screenWidth < 768 ? '40vh' : '30vh' }}>
                                <Col>
                                    {cart?.items ?
                                        cart.items.map(item => <CartItem key={`cart-item-${item.product_id}`} item={item} />) :
                                        <p className='text-secondary mb-0' style={{ fontSize: 24 }}>Your cart is empty</p>}
                                </Col>
                            </Row>

                            {
                                cart?.items &&
                                <>
                                    {/* TOTAL */}
                                    <Row className='justify-content-end my-3'>
                                        <Col lg={8}>
                                            <div className='border-bottom border-dark'>
                                                <Row>
                                                    <Col>
                                                        <p className='fw-bold' style={{ fontSize: 18 }}>Total:</p>
                                                    </Col>
                                                    <Col>
                                                        <Stack direction='horizontal' gap={2} className='align-items-center'>
                                                            <span className={`${ESW_CLASSNAMES.CART_TOTAL} fw-bold`} style={{ fontSize: 22 }}>
                                                                {
                                                                    (country && cart) &&
                                                                    `${country.node.currency_symbol}${Number(cart?.total_discount ? cart.total_cart_price - cart.total_discount : cart.total_cart_price).toFixed(2)}`
                                                                }
                                                            </span>
                                                            {(somePromotion || cart?.total_discount) && <Subtotal />}
                                                        </Stack>
                                                    </Col>
                                                </Row>
                                            </div>
                                            <PromoCode />
                                            <p className='fw-medium mb-2' style={{ fontSize: 14 }}>
                                                Checkout with ESW
                                            </p>
                                            <p className='fw-medium' style={{ fontSize: 14 }}>
                                                By clicking ‘PROCEED TO CHECKOUT’, you will be redirected to the ESW checkout page where payment will be taken and your order fulfilled by ESW, {brandName}’s preferred partner for international sales.
                                            </p>
                                            <p className='fw-medium' style={{ fontSize: 14 }}>
                                                Important - AIR now uses <a href="https://profile.inmusicbrands.com/" target="_blank" rel="noreferrer" className='text-black text-decoration-underline'>inMusic Profile</a> to manage your purchases. To link your purchase please enter your inMusic Profile email in the cart. If you do not have one one will be created for you.
                                            </p>
                                        </Col>
                                    </Row>

                                    {/* CONTINUE BROWSING / PROCEED TO CHECKOUT */}
                                    <Row className='justify-content-end pb-5'>
                                        <Col md='auto'>
                                            <Button
                                                variant=''
                                                onClick={() => setShowCart(false)}
                                                className='text-uppercase ff-primary fw-medium flex-center gap-1 border border-black mb-3 mb-md-0'
                                                style={{ fontSize: 18, width: 290 }}
                                            >
                                                <img src={cancelicon} alt='' />
                                                Continue Browsing
                                            </Button>
                                        </Col>
                                        <Col md='auto'>
                                            {isFreeCheckout && <Button
                                                variant=''
                                                className={`text-uppercase ff-primary fw-medium flex-center gap-1 border border-primary bg-primary`}
                                                style={{ fontSize: 18, width: 290 }}
                                                onClick={() => setShowFreeCheckout(true)}
                                            >
                                                Register My Product
                                            </Button>}
                                            
                                            {/*  
                                                ELEMENT MUST NOT BE REMOVED FROM DOM FOR ESW
                                                JUST CHANGE DISPLAY TO NONE IF FREE CHECKOUT
                                            */}
                                            <Button
                                                variant=''
                                                className={`
                                                    ${isFreeCheckout ? 'd-none' : ''}
                                                    ${ESW_CLASSNAMES.CHECKOUT_BUTTON}
                                                    text-uppercase ff-primary fw-medium flex-center gap-1 border border-primary bg-primary
                                                `}
                                                style={{ fontSize: 18, width: 290 }}
                                                onClick={() => {
                                                    if (typeof window === `undefined`) return
                                                    const { singularSdk } = window
                                                    try{
                                                        singularSdk.event('sng_checkout_initiated', {
                                                            sng_attr_content_list: cart?.items.map(({ sku }) => sku),
                                                            sng_attr_quantity: cart?.items.length,
                                                            sng_attr_item_price: `${country?.node?.currency_symbol}${Number(cart?.total_discount ? cart?.total_cart_price - cart?.total_discount : cart?.total_cart_price).toFixed(2)}`,
                                                        })
                                                    } catch(e){
                                                        console.error(e)
                                                    }
                                                }}
                                            >
                                                <img src={creditcard} alt='' />
                                                Proceed To Checkout
                                            </Button>
                                        </Col>
                                    </Row>
                                </>
                            }
                        </Container>
                }
            </Container>

            {/* LINEAR GRADIENT UNDER THE CART */}
            <div
                onClick={() => setShowCart(false)}
                style={{
                    background: `linear-gradient(rgba(0,0,0,0.8), rgba(0,0,0,0.3))`,
                    flex: 1,
                }}
            />
        </div>
    )
}
